import React, { PureComponent } from 'react';
import Spinner from './Spinner';
import {
  isSomethingLoadingIsideIframe,
  isHeightDidNotChange,
  isHeightDidChange,
  isBurgerMenuActed,
  postAskHeightMessage,
  isNavClicked,
  addMessage,
  isITemplateMounted,
  isMountingTemplateHasBurgerMenu,
} from './utils';

const HEIGHT_UPDATE_TIMER = 1500;

class IFrame extends PureComponent {
  state = {
    iframeHeight: 0,
    loading: true,
    burgerOpen: false,
  };

  componentDidMount() {
    this.messages = [];
    this.useTimeout = true;
    window.addEventListener('message', this.onIframeResponse);
    document.documentElement.classList.add('modal-open');
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onIframeResponse);
    document.documentElement.classList.remove('modal-open');
  }

  componentDidUpdate(prevProps) {
    if (this.props.link !== prevProps.link) {
      return this.setState({
        iframeHeight: 0,
        loading: true,
      });
    }

    if (this.props.recheckHeight) {
      setTimeout(() => {
        this.setState({}, this.askHeightWithReset);
      }, 100);
    }
  }

  askHeight = () => {
    if (this.useTimeout || this.state.loading) {
      setTimeout(() => {
        postAskHeightMessage(this.props.innerRef);
      }, HEIGHT_UPDATE_TIMER);
    } else {
      postAskHeightMessage(this.props.innerRef);
    }
  };

  askHeightWithReset = () => {
    this.setState({ iframeHeight: 0 }, this.askHeight);
  };

  onIframeResponse = (message) => {
    const { onHeightChange: updateScroll } = this.props;
    const {
      data: { type, height, cycle, burgerOpen },
    } = message;
    const {
      state: { iframeHeight },
    } = this;

    this.messages = addMessage(
      { type, height, cycle, burgerOpen },
      this.messages
    );

    if (isHeightDidNotChange(this.messages, iframeHeight)) return;

    if (isITemplateMounted(this.messages)) this.useTimeout = false;

    if (isNavClicked(this.messages))
      this.setState({ iframeHeight: 0, loading: true }, updateScroll);

    if (isSomethingLoadingIsideIframe(this.messages)) updateScroll();

    if (isHeightDidChange(this.messages, iframeHeight))
      this.setState(
        {
          iframeHeight: this.state.burgerOpen ? '100%' : height,
          loading: false,
        },
        updateScroll
      );

    if (isBurgerMenuActed(this.messages))
      this.setState({ burgerOpen }, this.askHeightWithReset);
  };

  onIFrameLoad = async () => {
    if (isMountingTemplateHasBurgerMenu(this.messages)) return;

    setTimeout(
      () => postAskHeightMessage(this.props.innerRef),
      HEIGHT_UPDATE_TIMER
    );
  };

  render() {
    const { iframeHeight, loading } = this.state;
    const { link } = this.props;

    return (
      <Spinner loading={loading}>
        <div
          style={{
            height: iframeHeight,
          }}
        >
          <iframe
            title="template"
            onLoad={this.onIFrameLoad}
            src={`https://${link}`}
            ref={this.props.innerRef}
            scrolling="no"
          />
        </div>
      </Spinner>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <IFrame innerRef={ref} {...props} />
));
